/** @format */

import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import {
	homefieldIconAlertInfoOutlined,
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService
} from '@dsg-tech/homefield-angular-icons';
import { NgOptimizedImage } from '@angular/common';

@Component({
	selector: 'scorecard-score-reward',
	templateUrl: './score-reward.component.html',
	styleUrl: './score-reward.component.scss',
	imports: [HomefieldIconLibraryModule, NgOptimizedImage],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScoreRewardComponent {
	public scoreRewardIcon = 'assets/image/dsg_ScoreRewards_Card.svg';

	private readonly homefieldIconsLibraryService = inject(HomefieldIconsLibraryService);

	constructor() {
		this.homefieldIconsLibraryService.registerIcons([homefieldIconAlertInfoOutlined]);
	}
}
